import { FC, useEffect } from "react";
import s from "./RenderLoader.module.scss";
import { Timer } from "../../../shared/Timer/Timer";
import { popUp } from "../../../features/popUp/PopUp";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { setRenderHash } from "../../../redux/reducers/ui/uiReducer";
import { getAspectRatio, getQuality } from "../../../redux/reducers/ui/uiSelectors";
import { ScreenDimensionsService } from "../../../services/ScreenDimensionsService";
import { RenderApi } from "../../../processes/api/renderAndLoadImage";
import { changeShowModal } from "../../../redux/reducers/app/appReducer";
import { CloseIcon } from "../../../assets/svg/CloseIcon";

type RenderLoaderT = {
  closeFunc: any;
};

export const RenderLoader: FC<RenderLoaderT> = ({ ...props }) => {
  const { closeFunc } = props;
  const dispatch = useAppDispatch();
  // Compute dimensions from Redux aspectRatio and quality
  const aspectRatio = useAppSelector(getAspectRatio);
  const quality     = useAppSelector(getQuality);
  const dimsService = new ScreenDimensionsService();
  const dimensions  = dimsService.calculateFromAspectRatio(aspectRatio, quality);
  const api         = new RenderApi();

  async function rendered() {
    // const data = await renderScene(closeFunc)
    // Render with explicit dimensions from UI
    const data = await api.renderWithDimensions(
      {
        renderWidth:  dimensions.width,
        renderHeight: dimensions.height,
        imageWidth:   dimensions.width,
        imageHeight:  dimensions.height,
      },
      closeFunc
    );
    //@ts-ignore
    const stopwatch = window.stopwatch;
    if (data.status === "success" && stopwatch) {
      // handleImage({ base64Image: data.imageBase64, type: "preview" });
      dispatch(
        changeShowModal({
          nameModal: "renderPreview",
          stateModal: true,
          otherParams: { img: data.imageUrl },
        })
      );
      setTimeout(() => {
        popUp({ type: "success", message: "Image uploaded successfully." });
      });

      // stopwatch.reset();
      // stopwatch.stop();
      dispatch(
        changeShowModal({
          nameModal: "renderLoader",
          stateModal: false,
          otherParams: { img: data.imageBase64 },
        })
      );
    }
    if (data.status === "pending") {
      dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));

      setTimeout(() => {
        popUp({ type: "success", message: "Image uploading ..." });
      }, 1500);
      dispatch(setRenderHash({ hash: data.configHash }));
    }
  }

  useEffect(() => {
    rendered();
  }, []);

  function stopRender() {
    dispatch(setRenderHash({ hash: "" }));
    dispatch(changeShowModal({ nameModal: "loader", stateModal: false }));

    //@ts-ignore
    const stopwatch = window.stopwatch;
    // stopwatch.reset();
    // stopwatch.stop();
    //@ts-ignore
    window.stopwatch = undefined;

    closeFunc();
  }

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className={s.header_title}>Rendering</div>
        <button onClick={() => stopRender()}><CloseIcon /></button>

      </div>
      <div className={s.content}>
        <Timer />
        <p>Your rendering will be ready shortly</p>
        <p>
          Decided to change something in the configuration?
          <br />
          You can stop the rendering and make all the necessary changes
        </p>
        <div className={s.hintStop} onClick={stopRender}>
          Stop
        </div>
      </div>
    </div>
  );
};
